export const truncateWithEllipsis = (string: string | undefined | null, maxLength: number): string | undefined | null => {
    if (!string || string?.length <= maxLength) return string;

    // If maxLength is < 3 just return all 3 dots to simplify logic
    return string.slice(0, Math.max(maxLength - 3, 0)) + '...';
};
